export default [
  {
    path: '/b2bhub/operacoes/pedido-vendas',
    name: 'pedidos-vendas',
    component: () => import('@/views/app/operacoes/pedidosVendas/pedidosVendas.vue'),
    meta: {
      pageTitle: 'Pedidos',
      action: 'read',
      resource: 'PedidosVenda',
    },

  },
  {
    path: '/b2bhub/operacoes/pedido-vendas/create',
    name: 'pedidos-vendas-create',
    component: () => import('@/views/app/operacoes/pedidosVendas/createPedidos.vue'),
    meta: {
      pageTitle: 'Criar Pedido de Venda',
      action: 'read',
      resource: 'PedidosVenda',
    },

  },
  {
    path: '/b2bhub/operacoes/pedido-vendas/aprovacoes',
    name: 'pedidos-vendas-aprovacoes',
    component: () => import('@/views/app/operacoes/pedidosVendas/aprovacaoDoacoes.vue'),
    meta: {
      pageTitle: 'Aprovações de Doação',
      action: 'read',
      resource: 'PedidosAprovacao',
      explicitModule: true,
    },
  },
  {
    path: '/b2bhub/operacoes/pedido-vendas/detalhes/:pedidoid/:clienteid',
    name: 'pedidos-vendas-detalhes',
    component: () => import('@/views/app/operacoes/pedidosVendas/detalhesPedidoVenda.vue'),
    meta: {
      action: 'read',
      resource: 'PedidosVenda',
    },

  },
];
